import { Component, OnInit, Inject  } from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-rule',
  templateUrl: './rule.component.html',
  styleUrls: ['./rule.component.css']
})
export class RuleComponent implements OnInit {
  neww :any;
  info :any;
  foods = [
    {value: 'SMS', viewValue: 'SMS'},
    {value: 'Email', viewValue: 'Email'},
    {value: 'Push', viewValue: 'Push Notification'},
  ];
  foodss = [
    {value: 'Equal', viewValue: 'Equal(==)'},
    {value: 'Greater', viewValue: 'Greater(<)'},
    {value: 'Lesser', viewValue: 'Lesser(>)'},
    {value: 'Greater-Equal', viewValue: 'Greater-Equal(<=)'},
    {value: 'Lesser-Equal', viewValue: 'Lesser-Equal(>=)'},
  ];
  constructor(public dialogRef: MdDialogRef<RuleComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) { }
    onNoClick(): void {
      this.dialogRef.close();
    }
    addContact(){
      
    }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/rule/rule.component.ts